import { SET_PREGUNTA_ACTIVA } from "../actions/types";

const INITIAL_STATE = {
  id_instrumento: 0,
  id_pregunta: 10101,
  contador: 0,
  respuestas202: [],
  respuestas208: [],
  respuestas203: [],
  respuestas204: [],
  respuestas205: [],
  respuestas206: [],
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_PREGUNTA_ACTIVA:
      //console.log("Reducer Preguna Activa", action);
      return { ...state, ...action.payload };
    default:
      return state;
  }
};
